<template>
<div id="container">
			<div class="location">
				<ul>
					<li class="home">홈</li>
					<li>해상배상책임보험</li>
					<li>판매상품 소개</li>
				</ul>
			</div>

			<div class="pageTit">
				<div class="conWrap">
					<h2>판매상품 소개</h2>
				</div>
			</div>

			<div class="contents">
				<div class="conWrap">
					<div class="conStyle1">
						<ol class="num">
							<li>
								Columbus Transport Insurance
								<ol class="line">
									<li>Section 1 – Insurance for Care of Cargo (화물의 운송에 대한 보험)</li>
									<li>Section 2 – Insurance of Equipment (장비 보험)</li>
									<li>Section 3 – Third Party Liability Insurance (제3자 배상책임)</li>
									<li>Section 4 – Professional Indemnity (직업적 보상)</li>
									<li>Section 5 – Fines and Penalties (벌과금)</li>
									<li>Section 6 – Property (재산 및 시설물)</li>
									<li>Section 7 – Business Interruption (영업 손실)</li>
									<br/>
								</ol>
							</li>
							<li>
								MMIP (Marine, Aviation and Transport Multi-Modal Insurance Policy)
								<ul class="line">
									<li>Freight Services Industry Schedule (화물운송사업 담보 부문)</li>
									<li>Container/Trailer Schedule (컨테이너/트레일러 담보 부문)</li>
									<li>Port and Terminal Operator Liability Schedule (항만/터미널 운영업자 배상책임 담보 부문)</li>
									<li>Ship Agents Schedule (선박대리점 배상책임 담보 부문)</li>
									<li>Charterer's Liability Schedule (용선자 배상 책임 담부 부문)</li>
									<li>Freight Demurrage and Defense Schedule (운임 및 소송비용 담보 부문)</li>
								</ul>
								<br/>
							</li>
							<li>
								TT Club Cover (Through Transport Club)
								<div class="tabStyle3 mgl0">
									<table>
										<caption>TT Club Cover (Through Transport Club)</caption>
										<colgroup>
											<col width="50%">
											<col width="50%">
										</colgroup>
										<thead>
											<tr>
												<th scope="col" height="80">담보부문</th>
												<th scope="col">담보위험</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td class="tal" height="52">
													Cargo Handling Facility Cover
												</td>
												<td class="tal">
													피보험자의 보관이나, 관리, 주의하에 있는 화물, 컨테이너, 설비 선박이나 제3자의 재산에 입힌 물리적 손상에 대한 배상책임
												</td>
											</tr>
											<tr>
												<td class="tal" height="52">
													Ship Operator Cover
												</td>
												<td class="tal">
													해상 운송인 소유 또는 임차 장비에 대한 물리적 멸실/손상 및 배상 책임
												</td>
											</tr>
											<tr>
												<td class="tal" height="52">
													Transport and Logistics Operators Cover
												</td>
												<td class="tal">
													화물운송주선인 및 비운송주선인의 보관, 운송 및 인도 중 화물에 발생한 물리적 손상에 대한 배상책임
												</td>
											</tr>
											<tr>
												<td class="tal" height="52">
													Container Lessors
												</td>
												<td class="tal">
													소유 운송 장비의 임차 기간 중 발생한 장비에 대한 손상 및 제 3자 배상책임
												</td>
											</tr>
											<tr>
												<td class="tal" height="52">
													Port Authorities Cover
												</td>
												<td class="tal">
													항만 시설 운영 중 발생한 화물 및 제 3자의 재산에 입힌 물리적 손상에 대한 배상책임
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<br/>
							</li>
							<li>
								International Freight Movement Operators Insurance (국제화물운송업자 배상책임 보험)
								<ol class="line">
									<li>Section 1 – Goods Legal Liabiltiy (화물에 대한 법률상 배상책임)</li>
									<li>Section 2 – Professional Indemnity (전문직업인 배상책임)</li>
									<li>Section 3 – Trailers/Container All Risks (트레일러/컨테이너에 대한 전위험담보)</li>
									<li>Section 4 – Goods All Risks (화물에 대한 전위험담보)</li>
								</ol>
							</li>
						</ol>
					</div>
				</div>
			</div>
		</div>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import util from '@/common/util'
import { sessionUserInfo, load } from '@/common/sessionFactory'
import Header from '@/components/common/Header.vue'
import Footer from '@/components/common/Footer.vue'

</script>

<style>

</style>
